import { useCallback } from 'react';

import Stack from '@mui/material/Stack';

import { TradeTxFilters, TradeTxFilterKey, TradeTxFilterValue } from 'src/type/trade-tx';
import { SelectChangeEvent } from '@mui/material';
import { Dayjs } from 'dayjs';
import FilterDatePicker from 'src/components/filter-form/filter-date-picker';
import FilterSingleSelect from 'src/components/filter-form/filter-single-select';
import UserSearchAutocomplete, { UserOption } from 'src/components/ui-kit/user-search-autocomplete';
import { tradeTxTypeOptions } from './utils';

type Props = {
  filters: TradeTxFilters;
  onFilters: (name: TradeTxFilterKey, value: TradeTxFilterValue) => void;
  dateError: boolean;
  //
  productOptions: { label: string; value: string }[];
};

export default function TradeTxFiltersToolbar({
  filters,
  onFilters,
  dateError,
  productOptions,
}: Props) {
  const handleFilterName = useCallback(
    (user: UserOption | null) => {
      onFilters('name', user);
    },
    [onFilters]
  );

  const handleFilterProduct = useCallback(
    (event: SelectChangeEvent<string>) => {
      onFilters('productId', event.target.value);
    },
    [onFilters]
  );

  const handleFilterStartDate = useCallback(
    (newValue: Dayjs | null) => {
      onFilters('startDate', newValue);
    },
    [onFilters]
  );

  const handleFilterEndDate = useCallback(
    (newValue: Dayjs | null) => {
      onFilters('endDate', newValue);
    },
    [onFilters]
  );

  const handleFilterType = useCallback(
    (event: SelectChangeEvent<string>) => {
      onFilters('type', event.target.value);
    },
    [onFilters]
  );

  return (
    <Stack
      spacing={2}
      alignItems={{ xs: 'flex-end', md: 'center' }}
      direction={{
        xs: 'column',
        md: 'row',
      }}
    >
      <FilterSingleSelect
        label="ประเภทธุรกรรม"
        sx={{ width: { xs: 1, md: 180 } }}
        value={filters.type}
        onChange={handleFilterType}
        options={tradeTxTypeOptions}
      />

      <FilterSingleSelect
        label="ประเภทสินค้า"
        sx={{ width: { xs: 1, md: 180 } }}
        value={filters.productId}
        onChange={handleFilterProduct}
        options={productOptions}
      />

      <FilterDatePicker
        label="จากวันที่"
        value={filters.startDate}
        onChange={handleFilterStartDate}
      />
      <FilterDatePicker
        label="ถึงวันที่"
        value={filters.endDate}
        onChange={handleFilterEndDate}
        dateError={dateError}
      />

      <Stack direction="row" alignItems="center" spacing={2} flexGrow={1} sx={{ width: 1 }}>
        <UserSearchAutocomplete value={filters.name} onChange={handleFilterName} />
      </Stack>
    </Stack>
  );
}
